import { Table } from "@organisms"
import TableView from "@organisms/ObjectsView/TableView/TableView"

export default function VendorCreditTableView() {
    return (
        <TableView.Table>
            <Table.Column<VendorCredit>
                accessorKey="id"
                header="ID"
                size={144}
                cell={({ row }) => <Table.Cells.IDCell id={row.original.custom_id || row.original.id} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<VendorCredit>
                accessorKey="vendor_name"
                header="Vendor Name"
                size={288}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<VendorCredit>
                accessorKey="vendor_credit_note_id"
                header="Vendor Credit Note ID"
                size={176}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<VendorCredit>
                accessorKey="status_label"
                header="Status"
                size={176}
                cell={({ getValue }) => <Table.Cells.StatusCell objectType="vendor_credit" status={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<VendorCredit>
                accessorKey="labels"
                header="Labels"
                size={240}
                cell={({ getValue }) => (
                    <Table.Cells.BadgesCell
                        badges={(getValue() as VendorCreditLabel[])?.map((label: VendorCreditLabel) => label.name)}
                    />
                )}
                enableSorting={false}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<VendorCredit>
                accessorKey="subtotal"
                header="Total"
                size={144}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={true}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            <Table.Column<VendorCredit>
                accessorKey="amount_applied"
                header="Applied"
                size={144}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={false}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            <Table.Column<VendorCredit>
                accessorKey="amount_remaining"
                header="Remaining"
                size={144}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={false}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            <Table.Column<VendorCredit>
                accessorKey="bill_id"
                header="Bill ID"
                size={144}
                cell={({ getValue }) => <Table.Cells.IDCell id={getValue() || "—"} />}
                enableSorting={false}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<VendorCredit>
                accessorKey="date_issued"
                header="Date Issued"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<VendorCredit>
                accessorKey="last_modified_at"
                header="Last Modified"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
        </TableView.Table>
    )
}
